import { type TabContent, type TabProps } from '../../../components/tabs';

export const getExportPropTypes = (tab: TabProps, nodes: any[]): TabContent['exportPropTypes'] => {
	const nodeWithExportPropTypes = nodes.find(
		(node: any) => node.exportPropTypes && tab.name === node.parent?.name,
	);

	if (nodeWithExportPropTypes) {
		return JSON.parse(nodeWithExportPropTypes.exportPropTypes);
	} else {
		return tab.content.exportPropTypes;
	}
};
